export const ELE_IDS = {
  REG_FORM_ID: 'conversation-registration-form',
  OTP_FORM_ID: 'conversation-otp-form',
  FLOW_ID: 'conversation-form',
};

export const ATTRIBUTION_PROGRAM_MAPPING = {
  academy: 'software_development',
  ai_ml: 'ai_ml',
};

export const REG_FORM_ERROR_MESSAGES = {
  429: 'Request rate exceeded, please try after sometime',
  422: 'Please fill the required fields',
  403: 'Email already registered',
  406: 'Recaptcha validity has expired, please try refreshing the page',
};

export const OTP_FORM_ERROR_MESSAGES = {
  429: 'Request rate exceeded, please try after sometime',
  422: 'Please fill the required fields',
  403: 'Fill the details and click on Get Verification Code first',
  409: 'Phone number is linked to a different email',
  401: 'Incorrect Verification Code entered',
  404: 'Fill the details and click on Get Verification Code first',
};
